import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class WidgetManager {
  constructor() {
    _defineProperty(this, "widgets", []);
    /**
     * We only have this because the way we're injecting the widget sections
     * ends up with the widgets rerendering on navigation.
     */
    _defineProperty(this, "states", {});
    _defineProperty(this, "config", {});
  }
  add(widget, extension) {
    widget.extension = extension;
    widget.id = `${extension}:${widget.key}`;
    this.widgets.push(widget);
    this.states[widget.id] = {};
  }
  getbyId(id) {
    return this.getWidgetInstances().find(w => w.id === id) || null;
  }
  getWidgetInstances() {
    const disabled = this.config.disabled || [];
    const widgets = (this.config.instances || []).map(widget => ({
      ...(this.widgets.find(w => w.id === widget.id) || {}),
      ...widget
    }));
    this.widgets.forEach(widget => {
      const lookupWidget = widgets.find(w => w.id === widget.id);
      if (!lookupWidget) {
        widgets.push(widget);
      }
    });
    return widgets.filter(widget => !disabled.includes(widget.id));
  }
  get(placement, withHidden) {
    if (withHidden === void 0) {
      withHidden = false;
    }
    const widgets = this.getWidgetInstances().filter(widget => widget.placement === placement).filter(widget => withHidden || (typeof widget.isDisabled === 'function' ? !widget.isDisabled() : !widget.isDisabled)).filter(widget => {
      // @TODO forgetting to add the extension name on the saved data forces us to split the ID
      // remove this in a future version and use extension value directly.
      const extension = widget.extension || widget.id.split(':')[0];
      return extension in flarum.extensions;
    }).map(widget => ({
      ...widget,
      extension: widget.extension || widget.id.split(':')[0],
      state: this.states[widget.id]
    }));
    return widgets;
  }
  setConfig(config) {
    this.config = config;
  }
}
flarum.reg.add('fof-forum-widgets-core', 'common/WidgetManager', WidgetManager);